import axios from "axios";

import {API_BASE_URL, BASE_URL} from "./consts";
import {toast} from "react-toastify";

export const createVipuskForDemand = async (data) => {
	try {
		const baseUrl = API_BASE_URL;
		const token = sessionStorage.getItem("token");

		// Convert field names to snake_case format
		const requestData = {
			furniture_id: data.furnitureId,
			unique_id: data.uniqueId,
			amount: data.amount,
			demand_furniture_id: data.demandFurnitureId,
			package_quantity: data.package_quantity,
			glass_quantity: data.glass_wood_quantity,
			glass_wood_quantity: data.glass_wood_quantity,
			lxdf_quantity: data.lxdf_quantity,
			status: true,
		};

		const config = {
			method: "post",
			url: `${baseUrl}/gotoviy/vipusks`,
			headers: {
				"Content-Type": "application/json",
				...(token && {Authorization: `Bearer ${token}`}),
			},
			data: requestData,
		};

		const response = await axios(config);
		return response.data;
	} catch (error) {
		console.error("Error creating vipusk:", error);
		throw error;
	}
};

export const createVipuskForSupermarket = async (data) => {
	try {
		const baseUrl = API_BASE_URL;
		const token = sessionStorage.getItem("token");

		// Convert field names to snake_case format
		const requestData = {
			tree_id: data.treeId,
			color_id: data.colorId,
			position_id: data.positionId,
			furniture_id: data.furnitureId,
			amount: data.amount,
			package_quantity: data.package_quantity,
			glass_quantity: data.glass_quantity,
			glass_wood_quantity: data.glass_wood_quantity,
			lxdf_quantity: data.lxdf_quantity,
		};

		console.log("Supermarket Request Data:", requestData, {baseUrl});

		const config = {
			method: "post",
			url: `${baseUrl}/gotoviy/vipusks/supermarket`,
			headers: {
				"Content-Type": "application/json",
				...(token && {Authorization: `Bearer ${token}`}),
			},
			data: requestData,
		};

		const response = await axios(config);
		return response.data;
	} catch (error) {
		console.error("Error creating vipusk for supermarket:", error);
		throw error;
	}
};

export const getFurniture = async (furnitureId) => {
	try {
		const baseUrl = API_BASE_URL;
		const token = sessionStorage.getItem("token");

		const config = {
			method: "GET",
			url: `${baseUrl}/gotoviy/demands/${furnitureId}/furnitures`,
			headers: {
				"Content-Type": "application/json",
				...(token && {Authorization: `Bearer ${token}`}),
			},
		};

		const response = await axios(config);
		return response.data;
	} catch (error) {
		if (error.response.data.message === "Demand not found") {
			toast.warning(`Buyurtma topilmadi`);
		} else {
			console.error("Error getting vipusks:", error);
			throw error;
		}
	}
};

export const getVipusks = async (page = 1) => {
	try {
		const baseUrl = API_BASE_URL;
		const token = sessionStorage.getItem("token");
		const sehId = sessionStorage.getItem(`sehId`);

		const config = {
			method: "GET",
			url: `${baseUrl}/gotoviy/vipusks?page=${page}&filterBySeh=${sehId}`,
			headers: {
				"Content-Type": "application/json",
				...(token && {Authorization: `Bearer ${token}`}),
			},
		};

		const response = await axios(config);
		return response.data;
	} catch (error) {
		console.error("Error getting vipusks:", error);
		throw error;
	}
};

export const getVipuskById = async (id) => {
	try {
		const baseUrl = API_BASE_URL;
		const token = sessionStorage.getItem("token");

		const config = {
			method: "GET",
			url: `${baseUrl}/gotoviy/vipusks/${id}`,
			headers: {
				"Content-Type": "application/json",
				...(token && {Authorization: `Bearer ${token}`}),
			},
		};

		const response = await axios(config);
		return response.data;
	} catch (error) {
		console.error("Error getting vipusks:", error);
		throw error;
	}
};

export const getCategories = async () => {
	try {
		const token = sessionStorage.getItem("token");

		const config = {
			method: "GET",
			url: `${BASE_URL}/api/categories`,
			headers: {
				"Content-Type": "application/json",
				...(token && {Authorization: `Bearer ${token}`}),
			},
		};

		const response = await axios(config);
		return response.data;
	} catch (error) {
		console.error("Error getting categories:", error);
		throw error;
	}
};

export const getTrees = async () => {
	try {
		const token = sessionStorage.getItem("token");

		const config = {
			method: "GET",
			url: `${BASE_URL}/api/trees`,
			headers: {
				"Content-Type": "application/json",
				...(token && {Authorization: `Bearer ${token}`}),
			},
		};

		const response = await axios(config);
		return response.data;
	} catch (error) {
		console.error("Error getting trees:", error);
		throw error;
	}
};

export const getTColors = async () => {
	try {
		const token = sessionStorage.getItem("token");

		const config = {
			method: "GET",
			url: `${BASE_URL}/api/colors`,
			headers: {
				"Content-Type": "application/json",
				...(token && {Authorization: `Bearer ${token}`}),
			},
		};

		const response = await axios(config);
		return response.data;
	} catch (error) {
		console.error("Error getting colors:", error);
		throw error;
	}
};
